import React from "react";

interface IconProps {
  className?: string;
  strokeWidth?: number;
}

const SuccessIcon: React.FC<IconProps> = ({ 
  className = "h-8 w-8 text-green-600", 
  strokeWidth = 2.5 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
};

export default SuccessIcon;